import React, { useState } from "react";
import { Layout, Breadcrumb } from "antd";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import HeaderBar from "./Header";
import routes from "../Routes/routes";

const { Content } = Layout;

const LayoutShell = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();

  /* Breadcrumb */
  const getBreadcrumb = () => {
    const path = location.pathname;

    for (let route of routes) {
      // Parent match
      if (route.path === path) {
        return ["Home", route.label];
      }

      // Child match
      if (route.children) {
        for (let child of route.children) {
          const fullPath = `${route.path}/${child.path}`;

          if (fullPath === path) {
            return ["Home", route.label, child.label];
          }
        }
      }
    }

    return ["Home"];
  };

  const crumbs = getBreadcrumb();

  return (
    <Layout className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      {/* Main */}
      <Layout
        className={`transition-all duration-300 ${
          collapsed ? "lg:ml-[80px]" : "lg:ml-[240px]"
        }`}
      >
        {/* Header */}
        <HeaderBar onToggleSidebar={() => setMobileOpen(true)} />

        {/* Content */}
        <Content className="mt-16 p-4 md:p-6 flex flex-col h-[calc(100vh-70px)]">
          <Breadcrumb className="mb-4 text-sm">
            {crumbs.map((c, i) => (
              <Breadcrumb.Item key={i}>
                <Link to="#">{c}</Link>
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>

          <div className="bg-white rounded-lg shadow p-4 flex-1 overflow-auto">
            {" "}
            <Routes>
              {routes.map((route) => {
                if (route.children) {
                  return (
                    <Route key={route.path} path={route.path}>
                      {route.children.map((child) => (
                        <Route
                          key={child.path}
                          path={child.path}
                          element={child.element}
                        />
                      ))}
                    </Route>
                  );
                }

                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                );
              })}
            </Routes>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutShell;
